import React from 'react'
import {
  IFeatureTabV2 as IContentfulFeatureTabV2,
  IFeatureTabContentV2 as IContentfulFeatureTabContentV2,
} from 'marketing-site/@types/generated/contentful'
import {
  IProps as IFeatureTabV2,
  FeatureTabV2,
  IFeatureTabContentProps,
} from 'marketing-site/src/library/components/FeatureTabV2'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import * as Utils from 'marketing-site/src/library/utils'
import { transformGridItem } from 'marketing-site/src/transformers/elements/ContentfulGridItem'
import { transformImage } from '../elements/ContentfulImage'

export const ContentfulFeatureTabV2 = (featureTabV2: IContentfulFeatureTabV2) => (
  <EntryMarker entry={featureTabV2}>
    {() => <FeatureTabV2 {...transformFeatureTabV2(featureTabV2)} />}
  </EntryMarker>
)

function transformFeatureTabContentV2({
  fields,
}: IContentfulFeatureTabContentV2): IFeatureTabContentProps {
  return {
    ...fields,
    image: transformImage(fields.image),
    items: fields.items.map((item) => transformGridItem(item, false)),
  }
}

export function transformFeatureTabV2({ fields }: IContentfulFeatureTabV2): IFeatureTabV2 {
  return {
    ...fields,
    bgColor: Utils.getHexColorFromName(fields.bgColor),
    featureTabContents: fields.featureTabContents.map((item) => transformFeatureTabContentV2(item)),
  }
}
